module.exports = __webpack_public_path__ + "img/reyinying.df9f26f3.png";